import { format } from 'date-fns'

import { type ListOrganizationMarginReportsResponse_MarginReportEntry } from '@enechain/eposition-proto/bffportal/v1/report_service_pb'

export type MarginReportEntryModel = {
  date: string // 'yyyy-MM-dd'
  deposits: number | null
  performanceGuarantee: number | null
  totalCreditAmount: number | null
  unrealizedAmount: number | null
  realizedAmount: number | null
  materializedUnsettledAmount: number | null // = max(realizedAmount + unrealizedAmount, 0)
  requiredMargin: number | null
  initialMargin: number | null
  surplus: number | null
  guaranteeIssuanceLimit: number | null
  isMarginCallDay: boolean
}

export function convertMarginReportEntryModel(
  entry: ListOrganizationMarginReportsResponse_MarginReportEntry,
): MarginReportEntryModel | null {
  const d = entry.date
  if (d === undefined) {
    return null
  }
  const date = format(new Date(d.year, d.month - 1, d.day), 'yyyy-MM-dd')
  if (entry.detail === undefined) {
    return {
      date,
      deposits: null,
      performanceGuarantee: null,
      totalCreditAmount: null,
      unrealizedAmount: null,
      realizedAmount: null,
      materializedUnsettledAmount: null,
      requiredMargin: null,
      initialMargin: null,
      surplus: null,
      guaranteeIssuanceLimit: null,
      isMarginCallDay: false,
    }
  }
  return {
    date,
    deposits: Number(entry.detail.totalCollateralAmount),
    performanceGuarantee: Number(entry.detail.performanceGuarantee),
    totalCreditAmount: Number(entry.detail.totalCreditAmount),
    unrealizedAmount: parseFloat(entry.detail.unrealizedAmount?.value ?? '0'),
    realizedAmount: parseFloat(entry.detail.realizedAmount?.value ?? '0'),
    materializedUnsettledAmount: parseFloat(
      entry.detail.materializedUnsettledAmount?.value ?? '0',
    ),
    requiredMargin: parseFloat(entry.detail.requiredMargin?.value ?? '0'),
    initialMargin: parseFloat(entry.detail.initialMargin?.value ?? '0'),
    surplus: parseFloat(entry.detail.surplus?.value ?? '0'),
    guaranteeIssuanceLimit: Number(entry.detail.guaranteeIssuanceLimit),
    isMarginCallDay: entry.detail.isMarginCallDay,
  }
}

export function convertMarginReportEntryModels(
  entries: ListOrganizationMarginReportsResponse_MarginReportEntry[],
): MarginReportEntryModel[] {
  return entries
    .map(convertMarginReportEntryModel)
    .filter((m): m is MarginReportEntryModel => m !== null)
}
